import { Box, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { PropsWithChildren } from 'react';

const useCommonTranslation = () => useTranslation('common');

export function ArticleNumber({ children }: PropsWithChildren) {
    const { t } = useCommonTranslation();

    if (!children) {
        return null;
    }

    return (
        <Box sx={{ my: '20px' }}>
            <Typography>
                {t('product.sku')}
                {' '}
                {children}
            </Typography>
        </Box>
    );
}
